import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";

interface LogTimekeepingIntegrationRetryAttemptParams {
  shiftId: string;
  workerId: string;
  workplaceId: string;
  action: string;
  attemptNumber: number;
  phase: string;
  elapsedTimeInSeconds: number;
}

interface LogTimekeepingIntegrationRetryExhaustedParams {
  shiftId: string;
  workerId: string;
  workplaceId: string;
  action: string;
  totalAttempts: number;
  totalElapsedTimeInSeconds: number;
}

export function logTimekeepingIntegrationRetryAttempt(
  params: LogTimekeepingIntegrationRetryAttemptParams
): void {
  const { shiftId, workerId, workplaceId, action, attemptNumber, phase, elapsedTimeInSeconds } =
    params;

  logEvent(APP_V2_USER_EVENTS.TIMEKEEPING_INTEGRATION_RETRY_ATTEMPT, {
    shiftId,
    workerId,
    workplaceId,
    action,
    attemptNumber,
    phase,
    elapsedTimeInSeconds,
  });
}

export function logTimekeepingIntegrationRetryExhausted(
  params: LogTimekeepingIntegrationRetryExhaustedParams
): void {
  const { shiftId, workerId, workplaceId, action, totalAttempts, totalElapsedTimeInSeconds } =
    params;

  logEvent(APP_V2_USER_EVENTS.TIMEKEEPING_INTEGRATION_RETRY_EXHAUSTED, {
    shiftId,
    workerId,
    workplaceId,
    action,
    totalAttempts,
    totalElapsedTimeInSeconds,
  });
}
